import React from "react";
import { useApi } from "@tiny/api";
import { usePostSegmentCloneMutation } from "@tiny/api";
import { CloneSegmentDialogProps } from "./CloneSegmentDialog";

export function useCloneSegmentDialog(props: CloneSegmentDialogProps) {
  const api = useApi();
  const { onSuccess, segmentId, open, onClose, name } = props;

  const [saving, setSaving] = React.useState(false);

  const [saveErrorMessage, setSaveErrorMessage] = React.useState<string>();

  const { mutateAsync: postSegmentCloneMutationAsync } =
    usePostSegmentCloneMutation();

  const closeErrorMessage = React.useCallback(() => {
    setSaveErrorMessage(undefined);
  }, []);

  const reset = React.useCallback(() => {
    setSaving(false);
    setSaveErrorMessage(undefined);
  }, []);

  const saveAs = React.useCallback(
    async (name: string) => {
      setSaving(true);
      setSaveErrorMessage(undefined);
      try {
        const { data: nameIsUsed } = await api.getSegmentCheckExists({ name });
        if (nameIsUsed) {
          setSaveErrorMessage("This segment name already exist.");
        } else {
          const { id } = await postSegmentCloneMutationAsync({
            data: {
              cloneSegmentId: segmentId,
              name,
            },
          });
          onSuccess(id!);
          onClose();
        }
      } catch (e) {
        setSaveErrorMessage("Something went wrong");
      } finally {
        setSaving(false);
      }
    },
    [onClose, onSuccess, postSegmentCloneMutationAsync, segmentId]
  );

  return {
    segmentId,
    saveAs,
    saveErrorMessage,
    saving,
    closeErrorMessage,
    open,
    onClose,
    name,
    reset,
  };
}
